import {all} from "redux-saga/effects";
import {togglePresetActiveStateWatcher} from "./editSystemServerVersion.saga";
import {getSystemServerVersionsWatcher} from "./getSystemServerVersions.saga";

export default function* rootSaga() {
    yield all([
        getSystemServerVersionsWatcher(),
        togglePresetActiveStateWatcher()
    ]);
}
